export default [
  {
    header: 'Генератор',
    resource: 'generator',
    action: 'view',
  },
  {
    title: 'Пакеты',
    route: 'generator-packs',
    icon: 'PackageIcon',
    resource: 'generator',
    action: 'view',
  },
]
